import { Flex } from "@chakra-ui/layout";
import { Box, Text } from "@chakra-ui/react";
import { Popover } from "antd";
import { ContaParcela } from "core/features/conta/typings";
import { OperacaoEnum } from "core/resources/enums/conta";
import { PermissaoEnum } from "core/resources/enums/permissao";
import colors from "core/resources/theme/colors";
import React, { useState } from "react";
import { MdKeyboardArrowDown, MdEdit } from "react-icons/md";
import OutlineButton from "ui/components/Button/OutlineButton";

function OutrasParcelas({
  outrasParcelas,
  onClickParcela,
  operacao,
}: {
  outrasParcelas: ContaParcela[];
  onClickParcela: (id: string) => any;
  operacao: OperacaoEnum;
}) {
  const [popoverVisible, setPopoverVisible] = useState(false);

  const onClose = () => setPopoverVisible(false);

  return (
    <Flex>
      <Popover
        placement="bottomRight"
        arrowContent={<></>}
        arrowPointAtCenter={false}
        overlayClassName="antd-popover-hide-arrow"
        trigger="click"
        visible={popoverVisible}
        onVisibleChange={setPopoverVisible}
        getPopupContainer={(node: any) => node.parentNode}
        overlayStyle={{
          borderRadius: 12,
          zIndex: 3,
          marginLeft: 10,
        }}
        overlayInnerStyle={{
          borderRadius: 12,
          boxShadow: "0 0 6px 2px #87878725",
          border: `solid 1px ${colors.blue}`,
          marginTop: -10,
          marginRight: -2,
        }}
        content={() => (
          <PopoverContent
            outrasParcelas={outrasParcelas}
            onClickParcela={onClickParcela}
            onClose={onClose}
            operacao={operacao}
          />
        )}
      >
        <OutlineButton lineColor={colors.blue} p={3}>
          <Text>Outras parcelas desse grupo</Text>

          <Box w="20px" ml={-2}>
            <MdKeyboardArrowDown size={25} />
          </Box>
        </OutlineButton>
      </Popover>
    </Flex>
  );
}

const PopoverContent = ({
  outrasParcelas,
  onClickParcela,
  operacao,
  onClose,
}: {
  outrasParcelas: ContaParcela[];
  onClickParcela: (id: string) => any;
  operacao: OperacaoEnum;
  onClose: () => any;
}) => (
  <Flex
    flexDir="column"
    alignItems="start"
    w="100%"
    maxW="360px"
    maxH="240px"
    overflowX="hidden"
    overflowY="auto"
  >
    {outrasParcelas.map((parcela) => (
      <OutlineButton
        p={2}
        mb={2}
        w="100%"
        justifyContent="start"
        border="none"
        permissions={
          operacao === OperacaoEnum.Despesa
            ? PermissaoEnum.Backoffice.Financeiro.ContasPagar.Editar
            : PermissaoEnum.Backoffice.Financeiro.ContasReceber.Editar
        }
        onClick={() => {
          onClickParcela(parcela.id!);
          onClose();
        }}
        _hover={{
          textDecoration: "underline",
        }}
      >
        <Box>
          <MdEdit size={16} />
        </Box>
        <Text noOfLines={2} textAlign="left" whiteSpace="pre-wrap">
          {parcela.numeroParcela} | {parcela.descricao}
        </Text>
      </OutlineButton>
    ))}
  </Flex>
);

export default OutrasParcelas;
